import { getSFxUser } from '../utils/checkSFxRoleAuth';
export var host = {
  apiHost: '',
  apiServiceSetting: {},
  getToken: function getToken() {
    var user = getSFxUser();
    return user && user.access_token || '';
  }
};
export var initHost = function initHost(obj) {
  var user = getSFxUser();

  if (user && user.profile) {
    host.apiHost = user.profile.PlatformUrl;
  }

  if (obj) {
    var apiHost = obj.apiHost,
        apiServiceSetting = obj.apiServiceSetting,
        getToken = obj.getToken;

    if (apiHost) {
      host.apiHost = apiHost;
    }

    if (apiServiceSetting) {
      host.apiServiceSetting = apiServiceSetting;
    }

    if (getToken) {
      host.getToken = function () {
        return getToken();
      };
    }
  }
};
export var getHost = function getHost() {
  return host;
};